import Vue from 'vue'
import axios from "axios"
import qs from 'qs'
import { BASE_URL } from '@/config'
import { getLoginInfo, FormUrlEnCodedUrl } from '@/api/config.js'


/**
 * 创建 axios 实例
 */
const service = axios.create({
	timeout: 60000,
	headers: {
		"Content-Type": "application/x-www-form-urlencoded"
	}
})

/**
 * req 拦截器
 */
service.interceptors.request.use((config) => {
	if(FormUrlEnCodedUrl.findIndex(o => config.url.indexOf(o) !== -1) !== -1){
		config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	}else{
		config.headers['Content-Type'] = 'application/json';
	}
	if(process.env.NODE_ENV !== 'development'){
		config.url = BASE_URL + config.url
	}
	config.headers['JEECMS-Auth-Token'] = getLoginInfo()['JEECMS-Auth-Token'] || '';
	return config
}, (error) => {
	return Promise.reject(error)
})

/**
 * res 拦截器
 */
service.interceptors.response.use(response => {
	let { status, data } = response;
	return {
		data: data.data || {},
		code: data.code === 200 ? 1 : data.code,
		msg: data.message || '请登录后操作'
	}
}, (response) => { // 请求错误做点什么
	if(response.request.status === 401){
		return {
			msg:  '请登录后操作'
		}
	}
	console.error('[axios error] ' + response);
	return response.data
})


function http(queryUrl, data, method) {
	let params = method === 'get' ? {
		params: data
	} : {
		// data: data
		data: FormUrlEnCodedUrl.findIndex(o => queryUrl.indexOf(o) !== -1) !== -1 ? qs.stringify(data) : data
	};
	return service({
		url: queryUrl,
		method: method,
		...params
	})
}
export default http
